/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1DocumentCourseEnrollmentDocument200,
  PostApiV1DocumentCourseEnrollmentDocument401,
  PostApiV1DocumentCourseEnrollmentDocument409,
  PostApiV1DocumentCourseEnrollmentDocument500,
  PostApiV1DocumentCourseEnrollmentDocumentMutationRequest,
  PostApiV1DocumentCourseEnrollmentDocumentMutationResponse,
} from "../../types/documentCourseController/PostApiV1DocumentCourseEnrollmentDocument.ts";
import { insertEnrollmentDocumentOfCourseViewModelSchema } from "../insertEnrollmentDocumentOfCourseViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1DocumentCourseEnrollmentDocument200Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentCourseEnrollmentDocument200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1DocumentCourseEnrollmentDocument401Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentCourseEnrollmentDocument401>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1DocumentCourseEnrollmentDocument409Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentCourseEnrollmentDocument409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1DocumentCourseEnrollmentDocument500Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentCourseEnrollmentDocument500>;

export const postApiV1DocumentCourseEnrollmentDocumentMutationRequestSchema =
  z.lazy(
    () => insertEnrollmentDocumentOfCourseViewModelSchema,
  ) as unknown as ToZod<PostApiV1DocumentCourseEnrollmentDocumentMutationRequest>;

export const postApiV1DocumentCourseEnrollmentDocumentMutationResponseSchema =
  z.lazy(
    () => postApiV1DocumentCourseEnrollmentDocument200Schema,
  ) as unknown as ToZod<PostApiV1DocumentCourseEnrollmentDocumentMutationResponse>;
